import * as actionTypes from "../actions/actionTypes";

const initialState = {
  authUser: null,
  token: null,
};

export const user = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SETUSER:
      return {
        ...state,
        authUser: action.authUser,
      };
    case actionTypes.SET_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    default:
      return state;
  }
};

export default user;
